/**
 * @generated SignedSource<<03d6a73febeb6c36c800bb9f56a9b918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OnlineStockStatus = "IN_STOCK" | "OUT_OF_STOCK";
export type useCartActionOverallStockQuery$variables = {
  offerIds: ReadonlyArray<string>;
};
export type useCartActionOverallStockQuery$data = {
  readonly onlineStock: {
    readonly stockStatus: OnlineStockStatus;
  };
  readonly storeStock: {
    readonly availability: number;
  };
};
export type useCartActionOverallStockQuery = {
  variables: useCartActionOverallStockQuery$variables;
  response: useCartActionOverallStockQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "offerIds",
    "variableName": "offerIds"
  }
],
v2 = [
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "OnlineStockResponse",
    "kind": "LinkedField",
    "name": "onlineStock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stockStatus",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "StoreStockResponse",
    "kind": "LinkedField",
    "name": "storeStock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availability",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCartActionOverallStockQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCartActionOverallStockQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a89e50fea047532ab87799fd9a1a1498",
    "id": null,
    "metadata": {},
    "name": "useCartActionOverallStockQuery",
    "operationKind": "query",
    "text": "query useCartActionOverallStockQuery(\n  $offerIds: [String!]!\n) {\n  onlineStock(offerIds: $offerIds) {\n    stockStatus\n  }\n  storeStock(offerIds: $offerIds) {\n    availability\n  }\n}\n"
  }
};
})();

(node as any).hash = "2223b78528d31be17cf193a3ba69ec7e";

export default node;
